module.exports = "/images/slide-qs-t-13.jpg";